<script>
    import HtmlCharity from "../../AAA_TO_REFACTOR/HtmlCharity.vue";
    import ClubSelect from '../../AAA_TO_REFACTOR/ClubSelect';

    export default {
        name: "default",
        components: {HtmlCharity, ClubSelect},
        props: {
            participantProp: {
                type: Object,
                default: () => ({}),
                required: true
            },
            members: {
                type: Object
            },
            defaultMember: {
                type: Object
            },
        },
        data() {
            return {
                registrationCategoryId: '',
                participant: {},
                selfParticipant: {},
            }
        },
        created() {
            this.participant = this.participantProp;

            if (!this.participant.hasOwnProperty('club') || this.participant.club == null) {
                this.participant.club = {
                    name: ''
                };
            }

            this.participant.dob = this.participantProp.dob ? moment(this.participantProp.dob).format('DD/MM/YYYY') : '';
            this.participant.gender = this.participant.gender || '';
            this.registrationCategoryId = this.participantProp.registration_category_id ? this.participantProp.registration_category_id : '';

            if (this.participantProp.booking_as == 'self') {
                this.selfParticipant.email = this.participantProp.email;
                this.selfParticipant.first_name = this.participantProp.first_name;
                this.selfParticipant.last_name = this.participantProp.last_name;
                this.selfParticipant.gender = this.participantProp.gender;
                this.selfParticipant.dob = this.participantProp.dob;
            }

        },
        computed: {
            memberCount() {
                if (this.members !== undefined) {
                    return Object.keys(this.members).length;
                }

                return 0;
            },
        },
        watch: {

            /**
             * watch participant.member_id and populate the fields with the members data
             * members are indexed by member_id
             *
             * @param newMemberId
             * @param oldMemberId
             */
            'participant.member_id': function (newMemberId, oldMemberId) {

                if (!this.memberCount) {
                    return;
                }

                // no member_id so clear all fields
                if (!newMemberId) {
                    this.clearFields();
                } else {
                    this.setFields(this.members[newMemberId]);
                }
            },
            'participant.booking_as': function (val, oldVal) {
                if (val == "other_adult") {
                    this.participant.email = "";
                    this.participant.first_name = "";
                    this.participant.last_name = "";
                    this.participant.gender = "";
                    this.participant.dob = "";
                } else {
                    this.participant.email = this.selfParticipant.email;
                    this.participant.first_name = this.selfParticipant.first_name;
                    this.participant.last_name = this.selfParticipant.last_name;
                    this.participant.gender = this.selfParticipant.gender;
                    this.participant.dob = this.selfParticipant.dob;

                }
            }
        },
        methods: {
            /**
             * If booking_as has been changed update the member_id
             * self - set member_id to default member
             * other_adult - clear the member_id
             * @param event
             */
            bookingAsUpdated(event) {
                // if booking as self default the member_id to default member
                if (event.target.value === 'self') {
                    this.participant.member_id = this.defaultMember !== null ? this.defaultMember.id : '';
                }

                // clear member id
                if (event.target.value === 'other_adult') {
                    this.participant.member_id = null;
                }
            },
            clearFields() {
                this.participant.email = '';
                this.participant.first_name = '';
                this.participant.last_name = '';
                this.participant.dob = '';
                this.participant.gender = '';
            },
            setFields(entity) {
                this.participant.email = entity.email;
                this.participant.first_name = entity.first_name;
                this.participant.last_name = entity.last_name;
                this.participant.dob = moment(entity.dob).format('DD/MM/YYYY');
                this.participant.gender = entity.gender;
            },
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Assets/components/Participants/Form/Default.vue